import React, { useState } from 'react';
import { SlideDown } from 'react-slidedown';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Price } from 'models/price';
import { getFormattedPrice } from 'utils/currency';

import {
  Arrow,
  Card,
  Division,
  Header,
  Label,
  Row,
  Section,
  Title,
  Total,
  TotalLabel,
  Value,
  PrivateFareIconContainer,
  PrivateFareMessage,
} from './styles';
import { ThemeType } from 'theme/theme';
import { useTheme } from 'styled-components';
import { ReactComponent as TicketIcon } from 'assets/images/private-fare.svg';
interface Props {
  price: Price;
  travelers: number;
  hasPrivateFare:boolean;
  alternativePrice: Price;
}

const PriceBox = ({ price, travelers, hasPrivateFare, alternativePrice }: Props) => {
  const theme = useTheme() as ThemeType;
  const { t } = useStoreTranslation();
  const [show, setShow] = useState(true);

  const formattedPrice = (value: number | undefined, currency: string) => {
    const { formatted } = getFormattedPrice({ value, currency, t });
    return formatted;
  };

  const discountValue =
    price.discountAmount && price.discountAmount > 0 ? price.discountAmount * -1 : price.discountAmount;

  return (
    <Card>
      <Header onClick={() => setShow(!show)}>
        <Title>{`${travelers} ${t('flightDetails.price.adult')}`}</Title>
        <Arrow className={show ? 'active' : ''} />
      </Header>
      <SlideDown closed={!show}>
        <Division />
        <Section>
          <Row>
            <Label>{t('flightDetails.price.fare')}</Label>
            <Value>{formattedPrice(price.amount, price.currencyCode)}</Value>
          </Row>
          <Row>
            <Label>{t('flightDetails.price.taxes')}</Label>
            <Value>
              {formattedPrice((price.taxes || price.taxesValue || 0) + (price.fees || 0) + (price.surcharges || 0), price.currencyCode)}
            </Value>
          </Row>
          <Row>
            <Label>{t('flightDetails.price.discount')}</Label>
            <Value>{formattedPrice(discountValue, price.currencyCode)}</Value>
          </Row>
        </Section>
        <Division />
        <Section>
          <Row>
            <TotalLabel>{t('flightDetails.price.total')}</TotalLabel>
            <Total>{formattedPrice(price.total, price.currencyCode)}</Total>
          </Row>
          {
            alternativePrice && alternativePrice.total > 0 && (
              <Row>
                <TotalLabel/>
                <Total>&nbsp;{t('alternativePrice.or')}&nbsp;{formattedPrice(alternativePrice.total, alternativePrice.currencyCode)}</Total>
              </Row>
            )
          }
          {hasPrivateFare && (
            <Row>
              <TotalLabel></TotalLabel>
              <Total>
                <PrivateFareMessage>
                  <PrivateFareIconContainer>
                    <TicketIcon stroke={theme.primaryBackgroundColor} />
                  </PrivateFareIconContainer>
                  {t('flightDetails.privateFare')}
                </PrivateFareMessage>
              </Total>
            </Row>
          )}
        </Section>
      </SlideDown>
    </Card>
  );
};

export default PriceBox;
